export default "#### Attenzione\n\nSembra che alcuni **prefissi di destinazione** non siano configurati, si prega di rivolgersi all'amministratore\n";